import { render, staticRenderFns } from "./UpsellsVirtual.vue?vue&type=template&id=202153a6"
import script from "./UpsellsVirtual.vue?vue&type=script&lang=js"
export * from "./UpsellsVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports